const VELURO_HOSTS = new Set([
  'veluro.ai',
  'www.veluro.ai',
  'localhost',
  '127.0.0.1',
]);

export const isCustomDomainHost = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.host.split(':')[0].toLowerCase();
  return !VELURO_HOSTS.has(host) && !host.endsWith('.veluro.page') && !host.endsWith('.emergentagent.com') && !host.endsWith('.emergent.host');
};
